/* karinex-blog.js — Verhalten der redaktionellen Artikelseite (2026-08).
 *
 * Ersetzt zwei Inline-Skripte aus sections/article-layout.liquid:
 * den Scroll-Listener der Fortschrittsleiste und das TOC-Skript aus
 * snippets/toc-generator.liquid. Der alte TOC-Code hatte einen echten
 * Anker-Bug: die Liquid-Seite baute hrefs mit | handleize (ü -> u),
 * das JS vergab IDs mit ue/oe/ae — bei jeder Überschrift mit Umlaut
 * zeigte der Link ins Leere. Deshalb vergibt dieses Skript die IDs
 * selbst UND schreibt die TOC-hrefs darauf um; verglichen wird über
 * den Textinhalt, mit Reihenfolge als Fallback.
 *
 * Kein Framework, ES5-Syntax (CLAUDE.md/ADR-001). IntersectionObserver
 * statt Scroll-Listener für den Scrollspy; fehlt er, bleibt das TOC
 * eine einfache, funktionierende Linkliste.
 */
(function () {
  'use strict';

  var content = document.getElementById('article-content');

  function headerOffset() {
    var v = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
    if (isNaN(v)) v = 0;
    return v + 16;
  }

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* egal */ }

  /* Lesefortschrittsleiste entfernt (Merchant 30.08.2026): der fixe Balken
     unter --header-height stand beim Scrollen als dunkler Strich frei über
     dem Inhalt, sobald der Site-Header ausgeblendet war. */

  /* ---- TOC: IDs vergeben, hrefs reparieren, Scrollspy ------------------- */
  if (content) {
    var headings = content.querySelectorAll('h2, h3');
    var i;
    for (i = 0; i < headings.length; i++) {
      if (!headings[i].id) headings[i].id = 'kxa-sec-' + (i + 1);
      /* Anker landen sonst unter dem Sticky-Header */
      headings[i].style.scrollMarginTop = headerOffset() + 8 + 'px';
    }

    var tocRoots = document.querySelectorAll('[data-kxa-toc]');
    var textOf = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''); };

    var byLink = [];
    for (var r = 0; r < tocRoots.length; r++) {
      var links = tocRoots[r].querySelectorAll('a[data-kxa-target]');
      for (i = 0; i < links.length; i++) {
        var want = links[i].getAttribute('data-kxa-target');
        if (want) want = want.replace(/&amp;/g, '&').replace(/\s+/g, ' ');
        var match = null;
        for (var h = 0; h < headings.length; h++) {
          if (textOf(headings[h]) === want) { match = headings[h]; break; }
        }
        /* Fallback: gleiche Position in der Liste */
        if (!match && headings[i]) match = headings[i];
        if (match) {
          links[i].setAttribute('href', '#' + match.id);
          byLink.push({ link: links[i], el: match });
        }
      }
    }

    /* Sanfter Anker-Sprung mit Header-Versatz */
    for (i = 0; i < byLink.length; i++) {
      (function (pair) {
        pair.link.addEventListener('click', function (e) {
          e.preventDefault();
          var top = pair.el.getBoundingClientRect().top + window.scrollY - headerOffset();
          window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
          /* Mobil: Accordion nach dem Sprung schließen */
          var det = pair.link.closest ? pair.link.closest('details[data-kxa-toc-mobile]') : null;
          if (det) det.removeAttribute('open');
          if (history.replaceState) history.replaceState(null, '', '#' + pair.el.id);
        });
      })(byLink[i]);
    }

    /* Scrollspy: aktive Sektion markieren */
    if (window.IntersectionObserver && byLink.length) {
      var activate = function (el) {
        for (var k = 0; k < byLink.length; k++) {
          if (byLink[k].el === el) {
            byLink[k].link.classList.add('is-active');
            byLink[k].link.setAttribute('aria-current', 'true');
          } else {
            byLink[k].link.classList.remove('is-active');
            byLink[k].link.removeAttribute('aria-current');
          }
        }
      };
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) current = entries[e].target;
        }
        if (current) activate(current);
      }, { rootMargin: '-' + (headerOffset() + 8) + 'px 0px -66% 0px', threshold: 0 });
      for (i = 0; i < headings.length; i++) io.observe(headings[i]);
    }
  }
})();
